'use client'

import React from 'react'

import CodeMinifierLayout from '../CodeMinifierLayout'
import minifyCSS from './minifyCSS'


export default function CSSMinifier() {
  return (
    <CodeMinifierLayout
      lang={'css'}
      minify={minifyCSS}
    />
  )
}
